// extracted by css-extract-rspack-plugin
export default {"cls1":"Comment-cls1_xL0","cls2":"Comment-cls2_aeU Comment-cls1_xL0"};